import { IImage } from '../Types/IImage'
import { baseAPI } from '../API/baseAPI'
import { iconBadImage } from '../UI/Icons/icons'

export const getImageUrl = (image: IImage): string => {
    if (!image) return iconBadImage
    return `${baseAPI}/${image.path}/${image.name}`
}
